import React, { useState, useEffect } from "react";
import { NotificationManager } from "react-notifications";
import { useSelector } from "react-redux";

import { Accordion } from "react-bootstrap";
import UnionIcon from "../../../assets/images/icons/Union_5.svg";
import { useTranslation } from "react-i18next";
import AppsRingBuilderService from "../../../services/apps-ringbuilder.service";
import { Select, Spin, Switch, Tooltip } from "antd";
import appsDiamondlinksService from "../../../services/apps-diamondlinks.service";

const { Option } = Select;

export const RingBuilderOptions = (props) => {
  const { t } = useTranslation();
  const [dealerId, setDealerId] = useState();
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [disableBtn, setDisableBtn] = useState(true);

  const [ViewOptionData, setViewOptionData] = useState({
    RingBuilderUrl: "",
    InternalUseLink: true,
    RingSizeType: "",
    InitiallySortbox1: "",
    InitiallySortbox2: "",
    DefaultMetalType: "",
    ShowAdvancedSearch: true,
    RingsShow: true,
    ShowAddress: true,
    ShowCenterStone: true,
    ShowDiamondShapeFilter: true,
    ShowVendorSKU: true,
    ShowPrice: true,
    GSTTax: true,
    GSTTaxValue: "",
    PinterestShare: true,
    TwitterShare: true,
    FacebookShare: true,
    FacebookLike: true,
    GooglePlus: true,
    InstagramShare: true,
    AddToCart: true,
    AltShoppingCart: "",
    ShowBuySetting: true,
    ShowBuyDiamond: true,
    ShowViewCart: true,
    isShowEcommerce: false,
  });

  const [diamondLinkOptionData, setDiamondLinkOptionData] = useState({
    showDiamondPrices: true,
    showLabGrownDiamondPrices: true,
  });

  const loginDetials = useSelector((state) => state.loginReducer);

  const DefaultMetalTypeList = [
    {
      title: (
        <Tooltip title={t("14k White Gold")}>{t("14k White Gold")}</Tooltip>
      ),
      ellipsis: true,
      value: "14k White Gold",
    },
    {
      title: (
        <Tooltip title={t("14k Yellow Gold")}>{t("14k Yellow Gold")}</Tooltip>
      ),
      ellipsis: true,
      value: "14k Yellow Gold",
    },
    {
      title: <Tooltip title={t("14k Rose Gold")}>{t("14k Rose Gold")}</Tooltip>,
      ellipsis: true,
      value: "14k Rose Gold",
    },
    {
      title: (
        <Tooltip title={t("18k White Gold")}>{t("18k White Gold")}</Tooltip>
      ),
      ellipsis: true,
      value: "18k White Gold",
    },
    {
      title: (
        <Tooltip title={t("18k Yellow Gold")}>{t("18k Yellow Gold")}</Tooltip>
      ),
      ellipsis: true,
      value: "18k Yellow Gold",
    },
    {
      title: <Tooltip title={t("18k Rose Gold")}>{t("18k Rose Gold")}</Tooltip>,
      ellipsis: true,
      value: "18k Rose Gold",
    },
    {
      title: <Tooltip title={t("Platinum")}>{t("Platinum")}</Tooltip>,
      ellipsis: true,
      value: "Platinum",
    },
  ];
  const InitiallySortbox2List = [
    {
      title: <Tooltip title={t("Ascending")}>{t("Ascending")}</Tooltip>,
      ellipsis: true,
      value: "ASC",
    },
    {
      title: <Tooltip title={t("Descending")}>{t("Descending")}</Tooltip>,
      ellipsis: true,
      value: "DESC",
    },
  ];

  const InitiallySortbox1List = [
    {
      title: <Tooltip title={t("Price")}>{t("Price")}</Tooltip>,
      ellipsis: true,
      value: "Price",
    },
    {
      title: <Tooltip title={t("Carat")}>{t("Carat")}</Tooltip>,
      ellipsis: true,
      value: "Carat",
    },
    {
      title: <Tooltip title={t("Color")}>{t("Color")}</Tooltip>,
      ellipsis: true,
      value: "Color",
    },
    {
      title: <Tooltip title={t("Clarity")}>{t("Clarity")}</Tooltip>,
      ellipsis: true,
      value: "Clarity",
    },
    {
      title: <Tooltip title={t("Cut Grade")}>{t("Cut Grade")}</Tooltip>,
      ellipsis: true,
      value: "Cut Grade",
    },
    {
      title: <Tooltip title={t("Certificate")}>{t("Certificate")}</Tooltip>,
      ellipsis: true,
      value: "Certificate",
    },
  ];

  const RingSizeTypeList = [
    {
      title: <Tooltip title={t("American")}>{t("American")}</Tooltip>,
      ellipsis: true,
      value: "American",
    },
    {
      title: <Tooltip title={t("British")}>{t("British")}</Tooltip>,
      ellipsis: true,
      value: "British",
    },
    {
      title: <Tooltip title={t("Roman")}>{t("Roman")}</Tooltip>,
      ellipsis: true,
      value: "Roman",
    },
    {
      title: <Tooltip title={t("Europe")}>{t("Europe")}</Tooltip>,
      ellipsis: true,
      value: "Europe",
    },
  ];

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleGetOptionsDetails(
            loginDetials.loginDetials.responseData.dealerId
          );
          handleGetOptionsDiamondDetails(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
  }, []);

  const onKeyPressEvent = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!new RegExp("[0-9.]").test(keyValue)) event.preventDefault();
    return;
  };

  const handleGetOptionsDetails = (id) => {
    let inputData = {
      dealerID: id,
      Type: "RingBuilder",
    };
    setLoading(true);
    try {
      AppsRingBuilderService.GetRingBuilderOptionDetails(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData[0];
          if (message === "Success") {
            if (responseData) {
              setLoading(false);
              setViewOptionData((prevState) => ({
                ...prevState,
                RingBuilderUrl: responseData.ringBuilderURL,
                InternalUseLink: responseData.internalLinkRB,
                RingSizeType: responseData.ringSizeType,
                InitiallySortbox1: responseData.ringInitiallySort1,
                InitiallySortbox2: responseData.ringInitiallySortDesc,
                DefaultMetalType: responseData.defaultMetalType,
                ShowAdvancedSearch: responseData.showAdvanceRingBuilder,
                RingsShow: responseData.showScheduleView,
                ShowAddress: responseData.showAddresses,
                ShowCenterStone: responseData.showCenterStoneSize,
                ShowDiamondShapeFilter: responseData.showDiamondFilter,
                ShowVendorSKU: responseData.showVendorSKU,
                ShowPrice: responseData.showPricesOnSearchPage,
                GSTTax: responseData.showGstPrice,
                GSTTaxValue: responseData.taxRate,
                PinterestShare: responseData.showPinterestShare,
                TwitterShare: responseData.showTwitterShare,
                FacebookShare: responseData.showFacebookShare,
                FacebookLike: responseData.showFacebookLike,
                GooglePlus: responseData.showGooglePlus,
                InstagramShare: responseData.showInstagramShare,
                AddToCart: responseData.showAddToCartButton,
                AltShoppingCart: responseData.shoppingCartURL,
                ShowBuySetting: responseData.showBuyWithoutCenterStone,
                ShowBuyDiamond: responseData.buyDiamondOnly,
                ShowViewCart: responseData.showViewCartButtonRB,
                isShowEcommerce: responseData.isShowEcommerce,
              }));
            }
          } else {
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleSubmit = () => {
    try {
      setSubmitLoading(true);
      let inputData = {
        dealerID: dealerId,
        type: "RingBuilder",
        ringBuilderURL: ViewOptionData.RingBuilderUrl,
        internalLinkRB: ViewOptionData.InternalUseLink,
        ringSizeType: ViewOptionData.RingSizeType,
        ringInitiallySort1: ViewOptionData.InitiallySortbox1,
        ringInitiallySortDesc: ViewOptionData.InitiallySortbox2,
        defaultMetalType: ViewOptionData.DefaultMetalType,
        showAdvanceRingBuilder: ViewOptionData.ShowAdvancedSearch,
        showScheduleView: ViewOptionData.RingsShow,
        showAddresses: ViewOptionData.ShowAddress,
        showCenterStoneSize: ViewOptionData.ShowCenterStone,
        showDiamondFilter: ViewOptionData.ShowDiamondShapeFilter,
        showVendorSKU: ViewOptionData.ShowVendorSKU,
        showPricesOnSearchPage: ViewOptionData.ShowPrice,
        showGstPrice: ViewOptionData.GSTTax,
        taxRate: ViewOptionData.GSTTaxValue ? ViewOptionData.GSTTaxValue : 0,
        showPinterestShare: ViewOptionData.PinterestShare,
        showTwitterShare: ViewOptionData.TwitterShare,
        showFacebookShare: ViewOptionData.FacebookShare,
        showFacebookLike: ViewOptionData.FacebookLike,
        showGooglePlus: ViewOptionData.GooglePlus,
        showInstagramShare: ViewOptionData.InstagramShare,
        showAddToCartButton: ViewOptionData.AddToCart,
        shoppingCartURL: ViewOptionData.AltShoppingCart,
        showBuyWithoutCenterStone: ViewOptionData.ShowBuySetting,
        buyDiamondOnly: ViewOptionData.ShowBuyDiamond,
        showViewCartButtonRB: ViewOptionData.ShowViewCart,
      };
      setLoading(true);
      AppsRingBuilderService.UpdateRingBuilderOptionDetails(inputData)
        .then((response) => {
          let message = response.data.message;

          setLoading(false);
          setSubmitLoading(false);
          if (message === "Success") {
            handleDiamondSubmit({
              showGstPrice: inputData.showGstPrice,
              taxRate: inputData.taxRate,
            });
          } else {
            NotificationManager.error(t("Data not Updated."));
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          setSubmitLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
      setSubmitLoading(false);
    }
    setDisableBtn(true);
  };

  const handleOnChange = (e, isSelect, name) => {
    setDisableBtn(false);

    if (isSelect === "select") {
      setViewOptionData({
        ...ViewOptionData,
        [name]: e,
      });
    } else {
      setViewOptionData({
        ...ViewOptionData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleDiamondSubmit = (gstOverride) => {
    try {
      setSubmitLoading(true);
      let inputData = {
        dealerID: dealerId,
        type: "DiamondLink",
        diamondLinkURL: diamondLinkOptionData.diamondLinkURL,
        internalLinkDL: diamondLinkOptionData.internalUseLink,
        allowNewDiamondDealers: diamondLinkOptionData.acceptNewDiamondDealers,
        searchSortName: diamondLinkOptionData.sortSearchResultsInitiallyBy,
        searchSortOrder: diamondLinkOptionData.orderSearchResultsInitiallyBy,
        showInhouseDiamonds: diamondLinkOptionData.showInHouseDiamondsSKU,
        showInhouseFirst: diamondLinkOptionData.showInHouseDiamondsFirst,
        displayVendorSku: diamondLinkOptionData.displayVendorSKU,
        showDiamondFilter: diamondLinkOptionData.showDiamondFilter,
        showGIAreportchecklink: diamondLinkOptionData.showGIAReportCheckLink,
        showAdvanceOptionInDiamondSearch:
          diamondLinkOptionData.showAdvanceOptionsAsDefault,
        showCertificateDiamondSearch:
          diamondLinkOptionData.showCertificateInDiamondSearch,
        showEGLVariants: diamondLinkOptionData.showEGLCertificateVariants,
        requestCer: diamondLinkOptionData.showRequestCertificate,
        disableCertificate: diamondLinkOptionData.disableCertificateLinks,
        showcoloritemsoutofrange:
          diamondLinkOptionData.showColorItemsOutOfRange,
        showclarityitemsoutofrange:
          diamondLinkOptionData.showClarityItemsOutOfRange,
        acceptTotalPrice: diamondLinkOptionData.acceptTotalPriceForDiamond,
        isScheduleViewing: diamondLinkOptionData.scheduleViewing,
        dropaHint: diamondLinkOptionData.dropAHint,
        emailAFriend: diamondLinkOptionData.emailAFriend,
        showOriginDiamondSearch:
          diamondLinkOptionData.showOriginOnDiamondSearch,
        showCommentsOnDetailPage:
          diamondLinkOptionData.showVendorCommentsOnDetailsPage,
        showContact: diamondLinkOptionData.showContactNumber,
        showAddresses: diamondLinkOptionData.showAddresses,
        searchPageDetailLinkURL:
          diamondLinkOptionData.alternateDiamondDetailsLinkURL,
        useCustomDetailURL: diamondLinkOptionData.customDetailURL,
        showDiamondPricesOnPage: diamondLinkOptionData.showDiamondPrices,
        showPricesOnSearchPageFancy:
          diamondLinkOptionData.showFancyColorDiamondPrices,
        showPricesOnSearchPageLab:
          diamondLinkOptionData.showLabGrownDiamondPrices,
        markupOwnInventory: diamondLinkOptionData.markupYourOwnInventory,
        showPricePerCarat: diamondLinkOptionData.showPricePerCarat,
        showGstPrice: gstOverride
          ? gstOverride.showGstPrice
          : diamondLinkOptionData.applyGstTax,
        taxRate: gstOverride ? gstOverride.taxRate : diamondLinkOptionData.gstTaxValue,
        showPinterestShare: diamondLinkOptionData.showPinterestShare,
        showTwitterShare: diamondLinkOptionData.showTwitterShare,
        showFacebookShare: diamondLinkOptionData.showFacebookShare,
        showFacebookLike: diamondLinkOptionData.showFacebookLike,
        showInstagramShare: diamondLinkOptionData.showInstagramShare,
        ShowGooglePlus: diamondLinkOptionData.ShowGooglePlus,
        showAddToCartButton: diamondLinkOptionData.ctaButton
          ? diamondLinkOptionData.myOptionRadio == "addToCartBtn"
            ? 1
            : diamondLinkOptionData.myOptionRadio == "scheduleAViewing"
            ? 2
            : diamondLinkOptionData.myOptionRadio == "requestMoreInfo"
            ? 0
            : 3
          : 3,
        alternateShoppingCartURL:
          diamondLinkOptionData.alternateShoppingCartURL,
        showViewCartButton: diamondLinkOptionData.showViewCartButton,
        showAddToCartButtonOnSearchPage:
          diamondLinkOptionData.showAddToCartButton,
      };
      setLoading(true);
      appsDiamondlinksService
        .UpdateDiamondLinkOptionDetailsUpload(inputData)
        .then((response) => {
          let message = response.data.message;

          setLoading(false);
          setSubmitLoading(false);
          if (message === "Success") {
            NotificationManager.success(t("Data Updated Successfully."));
            handleGetOptionsDiamondDetails(dealerId);
            handleGetOptionsDetails(dealerId);
          } else {
            NotificationManager.error(t("Data not Updated."));
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          setSubmitLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
      setSubmitLoading(false);
    }
    setDisableBtn(true);
  };

  const handleGetOptionsDiamondDetails = (id) => {
    let inputData = {
      dealerID: id,
      type: "DiamondLink",
    };
    setLoading(true);
    try {
      appsDiamondlinksService
        .GetOptionsDetails(inputData)
        .then((response) => {
          setLoading(false);

          let message = response.data.message;
          let responseData = response.data.responseData[0];
          if (message === "Success") {
            if (responseData) {
              setDiamondLinkOptionData((prevState) => ({
                ...prevState,
                diamondLinkURL: responseData.diamondLinkURL,
                internalUseLink: responseData.internalLinkDL,
                acceptNewDiamondDealers: responseData.allowNewDiamondDealers,
                sortSearchResultsInitiallyBy: responseData.searchSortName,
                orderSearchResultsInitiallyBy: responseData.searchSortOrder,
                showInHouseDiamondsSKU: responseData.showInhouseDiamonds,
                displayVendorSKU: responseData.displayVendorSku,
                showDiamondFilter: responseData.showDiamondFilter,
                showInHouseDiamondsFirst: responseData.showInhouseFirst,
                showGIAReportCheckLink: responseData.showGIAreportchecklink,
                showAdvanceOptionsAsDefault:
                  responseData.showAdvanceDiamondSearch,
                showCertificateInDiamondSearch:
                  responseData.showCertificateDiamondSearch,
                showEGLCertificateVariants: responseData.showEGLVariants,
                showRequestCertificate: responseData.requestCer,
                disableCertificateLinks: responseData.disableCertificate,
                showColorItemsOutOfRange: responseData.showcoloritemsoutofrange,
                showClarityItemsOutOfRange:
                  responseData.showclarityitemsoutofrange,
                acceptTotalPriceForDiamond: responseData.acceptTotalPrice,
                scheduleViewing: responseData.isScheduleViewing,
                dropAHint: responseData.dropaHint,
                emailAFriend: responseData.emailAFriend,
                showOriginOnDiamondSearch: responseData.showOriginDiamondSearch,
                showVendorCommentsOnDetailsPage:
                  responseData.showCommentsOnDetailPage,
                showContactNumber: responseData.showContact,
                showAddresses: responseData.showAddresses,
                alternateDiamondDetailsLinkURL:
                  responseData.searchPageDetailLinkURL,
                customDetailURL: responseData.useCustomDetailURL,
                showDiamondPrices: responseData.showPricesOnSearchPage,
                showFancyColorDiamondPrices:
                  responseData.showPricesOnSearchPageFancy,
                showLabGrownDiamondPrices:
                  responseData.showPricesOnSearchPageLab,
                markupYourOwnInventory: responseData.markupOwnInventory,
                showPricePerCarat: responseData.showPricePerCarat,
                applyGstTax: responseData.showGstPrice,
                gstTaxValue: responseData.taxRate,
                showPinterestShare: responseData.showPinterestShare,
                showTwitterShare: responseData.showTwitterShare,
                showFacebookShare: responseData.showFacebookShare,
                showFacebookLike: responseData.showFacebookLike,
                showInstagramShare: responseData.showInstagramShare,
                ShowGooglePlus: responseData.showGooglePlus,
                ctaButton:
                  responseData.showAddToCartButton == 1
                    ? true
                    : responseData.showAddToCartButton == 2
                    ? true
                    : responseData.showAddToCartButton == 0
                    ? true
                    : responseData.showAddToCartButton == 3
                    ? false
                    : null,
                alternateShoppingCartURL: responseData.alternateShoppingCartURL,
                myOptionRadio:
                  responseData.showAddToCartButton == 1
                    ? "addToCartBtn"
                    : responseData.showAddToCartButton == 2
                    ? "scheduleAViewing"
                    : responseData.showAddToCartButton == 0
                    ? "requestMoreInfo"
                    : null,
                showViewCartButton: responseData.showViewCartButton,
                showAddToCartButton:
                  responseData.showAddToCartButtonOnSearchPage,
                isShowEcommerce: responseData.isShowEcommerce,
              }));
            }
          } else {
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleOnDiamondLinkChange = (e, isSelect, name) => {
    setDisableBtn(false);
    if (isSelect === "select") {
      setDiamondLinkOptionData({
        ...diamondLinkOptionData,
        [name]: e,
      });
    } else {
      setDiamondLinkOptionData({
        ...diamondLinkOptionData,
        [e.target.name]: e.target.value,
      });
    }
  };

  return (
    <div className="form__fields markup__section">
      <div className="row ">
        <div className="col-md-12">
          <div className="heading__block">
            <h4 className="workarea__heading mt-0 mb-3"> {t("Options")} </h4>
          </div>
        </div>
      </div>

      <div className="row ">
        <Spin spinning={loading}>
          <div className="col-md-12">
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <div>
                    <label> {t("Setup")} </label>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Ring Builder URL")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Enter the URL of this tool on your site to enable social sharing and dynamic sizing."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <input
                          type="text"
                          className="mr-2"
                          name="RingBuilderUrl"
                          value={
                            ViewOptionData.RingBuilderUrl
                              ? ViewOptionData.RingBuilderUrl
                              : null
                          }
                          onChange={(e) => handleOnChange(e, "RingBuilderUrl")}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Internal Use Link?")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose Weather to display the “For Internal Use Only” link at the bottom of the Setting Details page, which will allow you to look up the vendor’s stock # and contact info for the viewed setting."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="InternalUseLink"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.InternalUseLink}
                          // onChange={handleSwitch}
                          onChange={(e) =>
                            handleOnChange(e, "select", "InternalUseLink")
                          }
                        />
                      </div>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <div>
                    <label htmlFor="h1"> {t("Display")} </label>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("RingSize Type")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose which Ring Size format you would like to display. (American - 1, 1.5, 2, etc. or British - A, A.5, B, B.5 etc.)."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Select
                          className="border__grey selct__inpt "
                          showSearch
                          placeholder={t("Choose Any")}
                          name="RingSizeType"
                          value={
                            ViewOptionData.RingSizeType
                              ? ViewOptionData.RingSizeType
                              : []
                          }
                          optionFilterProp="children"
                          onChange={(e) =>
                            handleOnChange(e, "select", "RingSizeType")
                          }
                        >
                          <Option value="">{t("Select Type")}</Option>
                          {RingSizeTypeList?.map((item, i) => {
                            return (
                              <Option value={item.value}>{item.title}</Option>
                            );
                          })}
                        </Select>
                      </div>
                    </div>

                    <div className="col-md-8">
                      <div className="input__block row ml-0 mr-0">
                        <label className="col-md-12">
                          {t("Diamond Initially Sort Result On")}
                        </label>
                        <div className="col-md-6 d-flex align-items-center">
                          <Select
                            className="border__grey selct__inpt"
                            showSearch
                            placeholder={t("Choose Any")}
                            name="InitiallySortbox1"
                            value={
                              ViewOptionData.InitiallySortbox1
                                ? t(ViewOptionData.InitiallySortbox1)
                                : []
                            }
                            optionFilterProp="children"
                            onChange={(e) =>
                              handleOnChange(e, "select", "InitiallySortbox1")
                            }
                          >
                            {InitiallySortbox1List?.map((item, i) => {
                              return (
                                <Option value={item.value}>{item.title}</Option>
                              );
                            })}
                          </Select>
                          <Tooltip
                            placement="right"
                            className="ml-1 info__icon"
                            title={t(
                              "Select a diamond attribute that you would like to initially sort the diamonds by."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </div>

                        <div className="col-md-6 d-flex align-items-center mobile__topspace">
                          <Select
                            className="border__grey selct__inpt"
                            showSearch
                            placeholder={t("Choose Any")}
                            name="InitiallySortbox2"
                            value={
                              ViewOptionData.InitiallySortbox2
                                ? ViewOptionData.InitiallySortbox2
                                : []
                            }
                            optionFilterProp="children"
                            onChange={(e) =>
                              handleOnChange(e, "select", "InitiallySortbox2")
                            }
                          >
                            {InitiallySortbox2List?.map((item, i) => {
                              return (
                                <Option value={item.value}>{item.title}</Option>
                              );
                            })}
                          </Select>
                          <Tooltip
                            placement="right"
                            className="ml-1 info__icon"
                            title={t(
                              "Select the desired initial sort order for your diamond attribute; choosing either Ascending or Descending sort order."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Default Metal Type on Setting page")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose Whether you would like a particular metal type to be set as the default when viewing a setting in RingBuilder."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Select
                          className="border__grey selct__inpt "
                          showSearch
                          placeholder={t("Choose Any")}
                          name="DefaultMetalType"
                          value={
                            ViewOptionData.DefaultMetalType
                              ? ViewOptionData.DefaultMetalType
                              : []
                          }
                          optionFilterProp="children"
                          onChange={(e) =>
                            handleOnChange(e, "select", "DefaultMetalType")
                          }
                        >
                          {DefaultMetalTypeList?.map((item, i) => {
                            return (
                              <Option value={item.value}>{item.title}</Option>
                            );
                          })}
                        </Select>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Advanced Search Options By Default")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose Whether to display the Advanced optional filtering by default (Polish, Symmetry, Flourescence, Certs… etc."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="ShowAdvancedSearch"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.ShowAdvancedSearch}
                          onChange={(e) =>
                            handleOnChange(e, "select", "ShowAdvancedSearch")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Rings - Show Schedule A Viewing")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose Whether to display the link which allows the customer the ability to schedule an appointment."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="RingsShow"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.RingsShow}
                          onChange={(e) =>
                            handleOnChange(e, "select", "RingsShow")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Addresses")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose Whether to display your company address and contact information within the RingBuilder."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="ShowAddress"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.ShowAddress}
                          onChange={(e) =>
                            handleOnChange(e, "select", "ShowAddress")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Center Stone Size")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Warning: Disabling this option will remove the Carat Range restriction for Ring Settings, and may cause an increase in cost prices from what is stated for the selected Ring Setting. For more information follow up with Overnight Mountings."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="ShowCenterStone"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.ShowCenterStone}
                          onChange={(e) =>
                            handleOnChange(e, "select", "ShowCenterStone")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Diamond Shape Filter")}
                          <Tooltip
                            placement="right"
                            title={t("Warning: Show Diamond Shape Filter.")}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="ShowDiamondShapeFilter"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.ShowDiamondShapeFilter}
                          onChange={(e) =>
                            handleOnChange(
                              e,
                              "select",
                              "ShowDiamondShapeFilter"
                            )
                          }
                        />
                      </div>
                    </div>


                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Display Vendor SKU")}
                          <Tooltip
                            placement="right"
                            title={t("Display Vendor SKU")}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="ShowVendorSKU"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.ShowVendorSKU}
                          onChange={(e) =>
                            handleOnChange(
                              e,
                              "select",
                              "ShowVendorSKU"
                            )
                          }
                        />
                      </div>
                    </div>


                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  <div>
                    <label> {t("Price")} </label>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Setting Price")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose Whether to show prices for ring settings or not. If you choose NO, then it will instead display “Call for Price”."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="ShowPrice"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.ShowPrice}
                          onChange={(e) =>
                            handleOnChange(e, "select", "ShowPrice")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Mined Diamond Price")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "You may choose not to show mined diamond prices in search results if desired. Price range field in search form is not displayed when prices are not displayed."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="showDiamondPrices"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          defaultChecked
                          checked={diamondLinkOptionData.showDiamondPrices}
                          onChange={(e) =>
                            handleOnDiamondLinkChange(
                              e,
                              "select",
                              "showDiamondPrices"
                            )
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Lab Grown Diamond Price")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "You may choose not to show lab grown diamond prices in search results if desired. Price range field in search form is not displayed when prices are not displayed."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="showLabGrownDiamondPrices"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          defaultChecked
                          checked={
                            diamondLinkOptionData.showLabGrownDiamondPrices
                          }
                          onChange={(e) =>
                            handleOnDiamondLinkChange(
                              e,
                              "select",
                              "showLabGrownDiamondPrices"
                            )
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Apply GST Tax")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Toggle the ability to apply international tax."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="GSTTax"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.GSTTax}
                          onChange={(e) =>
                            handleOnChange(e, "select", "GSTTax")
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("GST Tax Value")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Set the value when applying the GST Tax option."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <input
                          type="text"
                          className="mr-2"
                          name="GSTTaxValue"
                          value={
                            ViewOptionData.GSTTaxValue
                              ? ViewOptionData.GSTTaxValue
                              : null
                          }
                          onChange={(e) => {
                            handleOnChange(e, "GSTTaxValue");
                          }}
                          onKeyPress={onKeyPressEvent}
                        />
                      </div>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="5">
                <Accordion.Header>
                  <div>
                    <label> {t("Social")} </label>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="row">
                    
                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Instagram Share")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display the Instagram “Share” button or not."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="InstagramShare"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.InstagramShare}
                          onChange={(e) =>
                            handleOnChange(e, "select", "InstagramShare")
                          }
                        />
                      </div>
                    </div>

                    {/* <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Pinterest Share")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display the Pinterest “Pin it” button or not."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="PinterestShare"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.PinterestShare}
                          onChange={(e) =>
                            handleOnChange(e, "select", "PinterestShare")
                          }
                        />
                      </div>
                    </div> */}

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Twitter Share")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display the Twitter “Tweet” button or not."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="TwitterShare"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.TwitterShare}
                          onChange={(e) =>
                            handleOnChange(e, "select", "TwitterShare")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Facebook Share")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display the Facebook “Share” button or not."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="FacebookShare"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.FacebookShare}
                          onChange={(e) =>
                            handleOnChange(e, "select", "FacebookShare")
                          }
                        />
                      </div>
                    </div>

                    {/* <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Facebook Like")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display the Facebook “Like” button or not."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="FacebookLike"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={ViewOptionData.FacebookLike}
                          onChange={(e) =>
                            handleOnChange(e, "select", "FacebookLike")
                          }
                        />
                      </div>
                    </div> */}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              {ViewOptionData?.isShowEcommerce ? (
                <Accordion.Item eventKey="6">
                  <Accordion.Header>
                    <div>
                      <label> {t("E-Commerce")} </label>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="input__block">
                          <label>
                            {t("Show Add To Cart Button")}
                            <Tooltip
                              placement="right"
                              title={t(
                                "Choose Whether to display the “Add to Cart” button or not."
                              )}
                            >
                              <img src={UnionIcon} alt="" />
                            </Tooltip>
                          </label>
                          <Switch
                            name="AddToCart"
                            checkedChildren={t("Yes")}
                            unCheckedChildren={t("No")}
                            checked={ViewOptionData.AddToCart}
                            onChange={(e) =>
                              handleOnChange(e, "select", "AddToCart")
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="input__block">
                          <label>
                            {t("Alternate Shopping Cart")}
                            <Tooltip
                              placement="right"
                              title={t(
                                "Change this value to alter the actual hyperlink to the shopping cart. This could be changed to link to your own shopping cart page. Additional diamond and setting detail parameters are passed in the URL when this value is present. Leave blank for default value."
                              )}
                            >
                              <img src={UnionIcon} alt="" />
                            </Tooltip>
                          </label>
                          <input
                            type="text"
                            className="mr-2"
                            name="AltShoppingCart"
                            value={
                              ViewOptionData.AltShoppingCart
                                ? ViewOptionData.AltShoppingCart
                                : null
                            }
                            onChange={(e) =>
                              handleOnChange(e, "AltShoppingCart")
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="input__block">
                          <label>
                            {t("Show Buy Setting Only")}
                            <Tooltip
                              placement="right"
                              title={t(
                                "Choose Whether to display the “Buy Setting Only” button or not. This allows the customer to use the RingBuilder to only purchase the ring setting as opposed to the completed ring with diamond."
                              )}
                            >
                              <img src={UnionIcon} alt="" />
                            </Tooltip>
                          </label>
                          <Switch
                            name="ShowBuySetting"
                            checkedChildren={t("Yes")}
                            unCheckedChildren={t("No")}
                            checked={ViewOptionData.ShowBuySetting}
                            onChange={(e) =>
                              handleOnChange(e, "select", "ShowBuySetting")
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="input__block">
                          <label>
                            {t("Show Buy Diamond Only")}
                            <Tooltip
                              placement="right"
                              title={t(
                                "Choose Whether to display the “Buy Diamond Only” button or not. This allows the customer to use the RingBuilder to only purchase the diamond as opposed to the completed ring."
                              )}
                            >
                              <img src={UnionIcon} alt="" />
                            </Tooltip>
                          </label>
                          <Switch
                            name="ShowBuyDiamond"
                            checkedChildren={t("Yes")}
                            unCheckedChildren={t("No")}
                            checked={ViewOptionData.ShowBuyDiamond}
                            onChange={(e) =>
                              handleOnChange(e, "select", "ShowBuyDiamond")
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="input__block">
                          <label>
                            {t("Show")} "{t("View Cart")}" {t("Button")}
                            <Tooltip
                              placement="right"
                              title={t(
                                "Choose Whether to display the PayPal shopping cart's “view button” or Not"
                              )}
                            >
                              <img src={UnionIcon} alt="" />
                            </Tooltip>
                          </label>
                          <Switch
                            name="ShowViewCart"
                            checkedChildren={t("Yes")}
                            unCheckedChildren={t("No")}
                            checked={ViewOptionData.ShowViewCart}
                            onChange={(e) =>
                              handleOnChange(e, "select", "ShowViewCart")
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              ) : null}
            </Accordion>

            <div className="col-lg-12 mt-4">
              <button
                className={disableBtn ? "disabled-btn" : "primary-btn"}
                disabled={disableBtn}
                loading={submitLoading}
                onClick={() => {
                  handleSubmit();
                }}
              >
                {" "}
                {t("Update Settings")}{" "}
              </button>
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};
export default RingBuilderOptions;
